import React from 'react'
import PropTypes from 'prop-types'
import {
  CircularProgress,
  Grid,
  TextField,
  Typography,
  Checkbox,
  FormControlLabel,
} from '@material-ui/core'
import { FreeSolo } from 'components/FreeSolo'
import { SelectTextField } from 'components/SelectTextField'
import { useFormDescricaoVestigioBalistico } from './useFormDescricaoVestigioBalistico'
import { useStyles } from '../FormEditarDescricaoTecnica.styles'

export const FormDescricaoVestigioBalistico = (props) => {
  const { formDescricaoTecnica, tipoExame, descricaoDuplicada } = props
  const classes = useStyles()

  const {
    tiposArmaDeFogo,
    marcasArmaDeFogo,
    modelosArmaDeFogoFiltrados,
    calibresNominais,
    calibresNominaisCartucho,
    calibresCartuchosVariacaoFiltrados,
    locaisFabricacao,
    sistemasDePercussao,
    sistemasDeCarregamento,
    sistemasDeFuncionamento,
    tiposAlmaDeCano,
    tiposAcabamentoArmaDeFogo,
    numeracoesSerie,
    locaisGravacoesNumeracaoDeSerie,
    locaisGravacoesNumeracaoDeMontagem,
    tiposCarregadores,
    mecanismosDisparo,
    empunhaduras,
    coronhas,
    telhas,
    guardasMao,
    gravacoes,
    tiposTambores,
    fabricantesCartucho,
    capsulasEspoletamentoFiltrados,
    tiposEstojosFiltrados,
    tiposProjeteisFiltrados,
    especiesElementoMunicao,
    ressaltosCavadosFiltrados,
    tiposRaiamentos,
    tiposElementoRecarga,
    estadosConservacao,

    ocultarCalibreNominal,
    ocultarCalibreCompativel,
    ocultarLocaisGravacoesNumeracaoDeSerie,
    ocultarLocaisGravacoesNumeracaoDeMontagem,
    ocultarTambor,
    ocultarCarregador,
    ocultarCoronha,
    ocultarTelha,

    loading,
    numero,
    numeroMenorQueUnidades,
    numeroMenorQueQuantidade,
  } = useFormDescricaoVestigioBalistico({ formDescricaoTecnica, tipoExame, descricaoDuplicada })

  if (loading) {
    return (
      <div className={classes.carregando}>
        <CircularProgress disableShrink />
      </div>
    )
  }

  const tipoEspecifico = formDescricaoTecnica.formState.values.tipoVestigioEspecifico

  return (
    <Grid container style={{ width: '100%' }}>
      {['ARMA_DE_FOGO', 'ARMA_DE_PRESSAO'].includes(tipoEspecifico) && (
        <>
          <Grid item xs={12} className={classes.campoTitulo}>
            <Typography>DADOS DE IDENTIFICAÇÃO</Typography>
          </Grid>
          <Grid item container xs={12} className={classes.formContent} spacing={2}>
            <Grid item md={3} sm={6} xs={12}>
              <FreeSolo
                form={formDescricaoTecnica}
                required
                prop="tipoFabricacao"
                label="FABRICAÇÃO"
                options={['Industrial', 'Artesanal']}
              />
            </Grid>
            <Grid item md={3} sm={6} xs={12}>
              <FreeSolo
                form={formDescricaoTecnica}
                required
                prop="marca"
                label="MARCA"
                options={marcasArmaDeFogo}
              />
            </Grid>
            {tipoEspecifico === 'ARMA_DE_FOGO' && (
              <Grid item md={3} sm={6} xs={12}>
                <FreeSolo
                  form={formDescricaoTecnica}
                  required
                  prop="tipo"
                  label="TIPO"
                  options={tiposArmaDeFogo}
                />
              </Grid>
            )}
            <Grid item md={3} sm={6} xs={12}>
              <FreeSolo
                form={formDescricaoTecnica}
                required
                prop="modelo"
                label="MODELO"
                options={modelosArmaDeFogoFiltrados}
              />
            </Grid>
            {!ocultarCalibreNominal && (
              <Grid item md={3} sm={6} xs={12}>
                <FreeSolo
                  form={formDescricaoTecnica}
                  required
                  prop="calibreNominal"
                  label="CALIBRE NOMINAL"
                  options={calibresNominais}
                />
              </Grid>
            )}
            {!ocultarCalibreCompativel && (
              <Grid item md={6} sm={6} xs={12}>
                <TextField
                  required
                  label="CALIBRE COMPATÍVEL"
                  name="calibreCompativel"
                  variant="outlined"
                  value={formDescricaoTecnica.formState.values.calibreCompativel || ''}
                  onChange={formDescricaoTecnica.handleChange}
                  fullWidth
                  InputLabelProps={{
                    shrink: true,
                  }}
                />
              </Grid>
            )}
          </Grid>

          <Grid item xs={12} className={classes.campoTitulo}>
            <Typography>DADOS DE ORIGEM</Typography>
          </Grid>
          <Grid item container xs={12} className={classes.formContent} spacing={2}>
            <Grid item xs={12}>
              <SelectTextField
                form={formDescricaoTecnica}
                required
                prop="locFabs"
                label="LOCAL DE FABRICAÇÃO"
                propInput="localFabricacaoInput"
                labelInput="LOCAL DE FABRICAÇÃO (ESPECIFICAR)"
                options={locaisFabricacao}
                multiple
                isValoresObjeto
              />
            </Grid>
            <Grid item md={3} sm={6} xs={12}>
              <FreeSolo
                form={formDescricaoTecnica}
                required
                prop="numeracaoDeSerie"
                label="NUMERAÇÃO DE SÉRIE"
                options={numeracoesSerie}
              />
            </Grid>
            {!ocultarLocaisGravacoesNumeracaoDeSerie && (
              <Grid item md={9} sm={6} xs={12}>
                <SelectTextField
                  form={formDescricaoTecnica}
                  required
                  prop="locGravNumSers"
                  label="LOCAL DE GRAVAÇÃO DA NUMERAÇÃO DE SÉRIE"
                  propInput="localGravacaoNumeracaoSerieInput"
                  labelInput="LOCAL DE GRAVAÇÃO DA NUMERAÇÃO DE SÉRIE (ESPECIFICAR)"
                  options={locaisGravacoesNumeracaoDeSerie}
                  multiple
                  isValoresObjeto
                />
              </Grid>
            )}
            <Grid item md={3} sm={6} xs={12}>
              <FreeSolo
                form={formDescricaoTecnica}
                required
                prop="numeracaoDeMontagem"
                label="NUMERAÇÃO DE MONTAGEM"
                options={['Não aparente', 'Prejudicado']}
              />
            </Grid>
            {!ocultarLocaisGravacoesNumeracaoDeMontagem && (
              <Grid item md={9} sm={6} xs={12}>
                <SelectTextField
                  form={formDescricaoTecnica}
                  prop="locGravNumMons"
                  label="LOCAL DE GRAVAÇÃO DA NUMERAÇÃO DE MONTAGEM"
                  propInput="localGravacaoNumeracaoMontagemInput"
                  labelInput="LOCAL DE GRAVAÇÃO DA NUMERAÇÃO DE MONTAGEM (ESPECIFICAR)"
                  options={locaisGravacoesNumeracaoDeMontagem}
                  multiple
                  isValoresObjeto
                />
              </Grid>
            )}
          </Grid>

          <Grid item xs={12} className={classes.campoTitulo}>
            <Typography>CARACTERÍSTICAS DE OPERAÇÃO</Typography>
          </Grid>
          <Grid item container xs={12} className={classes.formContent} spacing={2}>
            <Grid item md={4} sm={6} xs={12}>
              <SelectTextField
                form={formDescricaoTecnica}
                required
                prop="sisPercs"
                label="SISTEMA DE PERCUSSÃO"
                propInput="sistemaPercussaoInput"
                labelInput="SISTEMA DE PERCUSSÃO (ESPECIFICAR)"
                options={sistemasDePercussao}
                isValoresObjeto
                multiple
              />
            </Grid>
            <Grid item md={4} sm={6} xs={12}>
              <SelectTextField
                form={formDescricaoTecnica}
                required
                prop="sisCarrs"
                label="SISTEMA DE CARREGAMENTO"
                propInput="sistemaCarregamentoInput"
                labelInput="SISTEMA DE CARREGAMENTO (ESPECIFICAR)"
                options={sistemasDeCarregamento}
                isValoresObjeto
                multiple
              />
            </Grid>
            <Grid item md={4} sm={6} xs={12}>
              <FreeSolo
                form={formDescricaoTecnica}
                required
                prop="sistemaFuncionamento"
                label="SISTEMA DE FUNCIONAMENTO"
                options={sistemasDeFuncionamento}
              />
            </Grid>
            <Grid item md={8} sm={6} xs={12}>
              <SelectTextField
                form={formDescricaoTecnica}
                required
                prop="almaCanos"
                label="ALMA DO CANO"
                propInput="almaCanoInput"
                labelInput="ALMA DO CANO (ESPECIFICAR)"
                options={tiposAlmaDeCano}
                isValoresObjeto
                multiple
              />
            </Grid>
            <Grid item md={4} sm={6} xs={12}>
              <FreeSolo
                form={formDescricaoTecnica}
                required
                prop="comprimentoCano"
                label="COMPRIMENTO DO CANO"
                options={['Prejudicado']}
                placeholder="Formato: XX mm"
              />
            </Grid>
          </Grid>

          <Grid item xs={12} className={classes.campoTitulo}>
            <Typography>CARACTERÍSTICAS GERAIS</Typography>
          </Grid>
          <Grid item container xs={12} className={classes.formContent} spacing={2}>
            <Grid item md={6} sm={6} xs={12}>
              <FreeSolo
                form={formDescricaoTecnica}
                required
                prop="acabamento"
                label="ACABAMENTO"
                options={tiposAcabamentoArmaDeFogo}
              />
            </Grid>
            {!ocultarTambor && (
              <Grid item md={6} sm={6} xs={12}>
                <SelectTextField
                  form={formDescricaoTecnica}
                  prop="tambores"
                  label="TAMBOR"
                  propInput="tamborInput"
                  labelInput="TAMBOR (ESPECIFICAR)"
                  options={tiposTambores}
                  isValoresObjeto
                  multiple
                />
              </Grid>
            )}
            {!ocultarCarregador && (
              <>
                <Grid item md={8} sm={6} xs={12}>
                  <SelectTextField
                    form={formDescricaoTecnica}
                    prop="carregadores"
                    label="CARREGADOR"
                    propInput="carregadorInput"
                    labelInput="CARREGADOR (ESPECIFICAR)"
                    options={tiposCarregadores}
                    isValoresObjeto
                    multiple
                  />
                </Grid>
                <Grid item md={4} sm={6} xs={12}>
                  <TextField
                    label="CAPACIDADE DO CARREGADOR"
                    name="capacidade"
                    variant="outlined"
                    value={formDescricaoTecnica.formState.values.capacidade || ''}
                    onChange={(e) => {
                      const input = e.target.value
                      const regex = /^[1-9]\d*$/
                      if (regex.test(input) || input === '') {
                        formDescricaoTecnica.handleChange(e)
                      }
                    }}
                    fullWidth
                    InputLabelProps={{
                      shrink: true,
                    }}
                  />
                </Grid>
              </>
            )}
            <Grid item md={4} sm={6} xs={12}>
              <SelectTextField
                form={formDescricaoTecnica}
                required
                prop="mecanDisps"
                label="MECANISMO DE DISPARO"
                propInput="mecanismoDisparoInput"
                labelInput="MECANISMO DE DISPARO (ESPECIFICAR)"
                options={mecanismosDisparo}
                isValoresObjeto
                multiple
              />
            </Grid>
            <Grid item md={4} sm={6} xs={12}>
              <FreeSolo
                form={formDescricaoTecnica}
                required
                prop="massaMira"
                label="MASSA DE MIRA"
                options={['Ausente', 'Fixa', 'Fixa (sistema de três pontos)', 'Regulável', 'Prejudicado', 'Outro']}
              />
            </Grid>
            <Grid item md={4} sm={6} xs={12}>
              <FreeSolo
                form={formDescricaoTecnica}
                required
                prop="alcaMira"
                label="ALÇA DE MIRA"
                options={['Ausente', 'Fixa', 'Fixa (sistema de três pontos)', 'Regulável', 'Prejudicado', 'Outro']}
              />
            </Grid>
            <Grid item md={4} sm={6} xs={12}>
              <SelectTextField
                form={formDescricaoTecnica}
                prop="empunhaduras"
                label="EMPUNHADURA"
                propInput="empunhaduraInput"
                labelInput="EMPUNHADURA (ESPECIFICAR)"
                options={empunhaduras}
                isValoresObjeto
                multiple
              />
            </Grid>
            {!ocultarCoronha && (
              <Grid item md={4} sm={6} xs={12}>
                <SelectTextField
                  form={formDescricaoTecnica}
                  prop="coronhas"
                  label="CORONHA"
                  propInput="coronhaInput"
                  labelInput="CORONHA (ESPECIFICAR)"
                  options={coronhas}
                  isValoresObjeto
                  multiple
                />
              </Grid>
            )}
            {!ocultarTelha && (
              <Grid item md={4} sm={6} xs={12}>
                <SelectTextField
                  form={formDescricaoTecnica}
                  prop="telhas"
                  label="TELHA"
                  propInput="telhaInput"
                  labelInput="TELHA (ESPECIFICAR)"
                  options={telhas}
                  isValoresObjeto
                  multiple
                />
              </Grid>
            )}
            <Grid item md={4} sm={6} xs={12}>
              <FreeSolo
                form={formDescricaoTecnica}
                prop="guardaMao"
                label="GUARDA-MÃO"
                options={guardasMao}
              />
            </Grid>
            <Grid item md={8} sm={6} xs={12}>
              <SelectTextField
                form={formDescricaoTecnica}
                prop="gravacoes"
                label="GRAVAÇÕES"
                propInput="gravacoesInput"
                labelInput="GRAVAÇÕES (ESPECIFICAR)"
                options={gravacoes}
                isValoresObjeto
                multiple
              />
            </Grid>
            <Grid item md={4} sm={6} xs={12}>
              <FreeSolo
                form={formDescricaoTecnica}
                prop="estadoConservacao"
                label="ESTADO DE CONSERVAÇÃO"
                options={estadosConservacao}
              />
            </Grid>
            <Grid item md={8} sm={12} xs={12}>
              <TextField
                label="OUTRAS CARACTERÍSTICAS"
                name="outrasCaracteristicas"
                variant="outlined"
                value={formDescricaoTecnica.formState.values.outrasCaracteristicas || ''}
                onChange={formDescricaoTecnica.handleChange}
                fullWidth
                InputLabelProps={{
                  shrink: true,
                }}
              />
            </Grid>
          </Grid>

          <Grid item xs={12} className={classes.campoTitulo}>
            <Typography>EXTRAÇÃO DE PADRÃO</Typography>
          </Grid>
          <Grid item container xs={12} className={classes.formContent} spacing={2}>
            <Grid item md={10} sm={12} xs={12} className={classes.fieldGroup}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={!!formDescricaoTecnica.formState.values.coletaPadrao}
                    onChange={formDescricaoTecnica.handleChange}
                    name="coletaPadrao"
                  />
                }
                label="Foi realizada coleta de padrões balísticos"
              />
            </Grid>
          </Grid>
        </>
      )}

      {['CARTUCHO', 'ESTOJO'].includes(tipoEspecifico) && (
        <>
          <Grid item xs={12} className={classes.campoTitulo}>
            <Typography>CARACTERÍSTICAS GERAIS</Typography>
          </Grid>
          <Grid item container xs={12} className={classes.formContent} spacing={2}>
            <Grid item md={3} sm={4} xs={12}>
              <TextField
                variant="outlined"
                label="UNIDADES"
                required
                fullWidth
                value={formDescricaoTecnica.formState.values.unidades}
                InputLabelProps={{
                  shrink: true,
                }}
                name="unidades"
                onChange={(e) => formDescricaoTecnica.handleChangeWithModification(e, numero)}
                error={formDescricaoTecnica.hasError('unidades')}
                helperText={
                  formDescricaoTecnica.hasError('unidades')
                    ? formDescricaoTecnica.formState.errors.unidades[0]
                    : null
                }
              />
            </Grid>
            {tipoEspecifico === 'CARTUCHO' && (
              <Grid item md={3} sm={4} xs={12}>
                <TextField
                  variant="outlined"
                  label="UNIDADES TESTADAS"
                  required
                  fullWidth
                  value={formDescricaoTecnica.formState.values.unidadesConsumidas}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  name="unidadesConsumidas"
                  onChange={(e) =>
                    formDescricaoTecnica.handleChangeWithModification(e, numeroMenorQueUnidades)
                  }
                  error={formDescricaoTecnica.hasError('unidadesConsumidas')}
                  helperText={
                    formDescricaoTecnica.hasError('unidadesConsumidas')
                      ? formDescricaoTecnica.formState.errors.unidadesConsumidas[0]
                      : null
                  }
                />
              </Grid>
            )}
            <Grid item md={3} sm={6} xs={12}>
              <FreeSolo
                form={formDescricaoTecnica}
                required
                prop="calibreNominal"
                label="CALIBRE NOMINAL"
                options={calibresNominaisCartucho}
              />
            </Grid>
            <Grid item md={3} sm={6} xs={12}>
              <FreeSolo
                form={formDescricaoTecnica}
                prop="calibreVariacao"
                label="VARIAÇÃO"
                options={calibresCartuchosVariacaoFiltrados}
              />
            </Grid>
            <Grid item md={3} sm={6} xs={12}>
              <FreeSolo
                form={formDescricaoTecnica}
                required
                prop="fabricante"
                label="FABRICANTE"
                options={fabricantesCartucho}
              />
            </Grid>
            <Grid item md={6} sm={6} xs={12}>
              <SelectTextField
                form={formDescricaoTecnica}
                required
                prop="capsulaEsps"
                label="CÁPSULA DE ESPOLETAMENTO"
                propInput="capsulaEspoletamentoInput"
                labelInput="CAPSULA DE ESPOLETAMENTO (ESPECIFICAR)"
                options={capsulasEspoletamentoFiltrados}
                isValoresObjeto
                multiple
              />
            </Grid>
            <Grid item md={6} sm={6} xs={12}>
              <SelectTextField
                form={formDescricaoTecnica}
                required
                prop="tipoEstojos"
                label="ESTOJO"
                propInput="tipoEstojoInput"
                labelInput="ESTOJO (ESPECIFICAR)"
                options={tiposEstojosFiltrados}
                isValoresObjeto
                multiple
              />
            </Grid>
            {tipoEspecifico === 'CARTUCHO' && (
              <Grid item md={6} sm={6} xs={12}>
                <SelectTextField
                  form={formDescricaoTecnica}
                  required
                  prop="tiposProjetil"
                  label="PROJÉTIL"
                  propInput="tipoProjetilInput"
                  labelInput="PROJETIL (ESPECIFICAR)"
                  options={tiposProjeteisFiltrados}
                  isValoresObjeto
                  multiple
                />
              </Grid>
            )}
            {tipoExame === 'IDENTIFICACAO_BALISTICA' && tipoEspecifico === 'ESTOJO' && (
              <Grid item md={6} sm={6} xs={12}>
                <FreeSolo
                  form={formDescricaoTecnica}
                  prop="formatoPercutor"
                  label="FORMATO DO PERCUTOR"
                  options={['Circular', 'Elíptico', 'Irregular', 'Prejudicado']}
                />
              </Grid>
            )}
            <Grid item md={6} sm={6} xs={12}>
              <FreeSolo
                form={formDescricaoTecnica}
                prop="numeroLote"
                label="NÚMERO DE LOTE"
                options={['Não aparente', 'Prejudicado']}
              />
            </Grid>
            <Grid item md={6} sm={6} xs={12}>
              <TextField
                label="ANO DE FABRICAÇÃO"
                name="gravacoesInput"
                variant="outlined"
                value={formDescricaoTecnica.formState.values.gravacoesInput || ''}
                onChange={formDescricaoTecnica.handleChange}
                fullWidth
                InputLabelProps={{
                  shrink: true,
                }}
              />
            </Grid>
            {tipoExame === 'CONFRONTO_BALISTICO' && (
              <Grid item md={6} sm={6} xs={12}>
                <TextField
                  label="IDENTIFICADOR"
                  name="outrasCaracteristicas"
                  variant="outlined"
                  placeholder="EQXX"
                  value={formDescricaoTecnica.formState.values.outrasCaracteristicas || ''}
                  onChange={formDescricaoTecnica.handleChange}
                  fullWidth
                  InputLabelProps={{
                    shrink: true,
                  }}
                />
              </Grid>
            )}
          </Grid>
        </>
      )}

      {tipoEspecifico === 'ELEMENTO_MUNICAO' && (
        <>
          <Grid item xs={12} className={classes.campoTitulo}>
            <Typography>CARACTERÍSTICAS GERAIS</Typography>
          </Grid>
          <Grid item container xs={12} className={classes.formContent} spacing={2}>
            <Grid item md={6} sm={6} xs={12}>
              <FreeSolo
                form={formDescricaoTecnica}
                required
                prop="tipo"
                label="ELEMENTO DE MUNIÇÃO"
                options={especiesElementoMunicao}
              />
            </Grid>
            <Grid item md={6} sm={6} xs={12}>
              <SelectTextField
                form={formDescricaoTecnica}
                required
                prop="ressaltosCavados"
                label="RESSALTOS E CAVADOS"
                propInput="ressaltosCavadosInput"
                labelInput="RESSALTOS E CAVADOS (ESPECIFICAR)"
                options={ressaltosCavadosFiltrados}
                isValoresObjeto
                multiple
              />
            </Grid>
            <Grid item md={7} sm={7} xs={12}>
              <SelectTextField
                form={formDescricaoTecnica}
                required
                prop="tiposProjetil"
                label="TIPO"
                propInput="tipoProjetilInput"
                labelInput="TIPO (ESPECIFICAR)"
                options={tiposProjeteisFiltrados}
                isValoresObjeto
                multiple
              />
            </Grid>
            <Grid item md={5} sm={5} xs={12}>
              <SelectTextField
                form={formDescricaoTecnica}
                required
                prop="tiposRaiamentos"
                label="TIPO DO RAIAMENTO"
                propInput="tiposRaiamentosInput"
                labelInput="TIPO DO RAIAMENTO (ESPECIFICAR)"
                options={tiposRaiamentos}
                isValoresObjeto
                multiple
              />
            </Grid>
            <Grid item md={3} sm={3} xs={12}>
              <FreeSolo
                form={formDescricaoTecnica}
                required
                prop="medidaMassa"
                label="MASSA (g)"
                options={['Prejudicado']}
                placeholder="Ex: 7.3"
              />
            </Grid>
            <Grid item md={3} sm={3} xs={12}>
              <FreeSolo
                form={formDescricaoTecnica}
                required
                prop="medidaDiametro"
                label="DIÂMETRO (mm)"
                options={['Prejudicado']}
                placeholder="Ex: 9.3"
              />
            </Grid>
            <Grid item md={3} sm={3} xs={12}>
              <FreeSolo
                form={formDescricaoTecnica}
                required
                prop="medidaComprimento"
                label="COMPRIMENTO (mm)"
                options={['Prejudicado']}
                placeholder="Ex: 19.3"
              />
            </Grid>
            <Grid item md={3} sm={6} xs={12}>
              <FreeSolo
                form={formDescricaoTecnica}
                required
                prop="calibreCompativel"
                label="CALIBRE COMPATÍVEL"
                options={calibresNominaisCartucho}
              />
            </Grid>
            {tipoExame === 'CONFRONTO_BALISTICO' && (
              <Grid item xs={12}>
                <TextField
                  label="IDENTIFICADOR"
                  name="outrasCaracteristicas"
                  variant="outlined"
                  placeholder="PQXX"
                  value={formDescricaoTecnica.formState.values.outrasCaracteristicas || ''}
                  onChange={formDescricaoTecnica.handleChange}
                  fullWidth
                  InputLabelProps={{
                    shrink: true,
                  }}
                />
              </Grid>
            )}
          </Grid>
        </>
      )}

      {tipoEspecifico === 'ELEMENTO_RECARGA' && (
        <>
          <Grid item xs={12} className={classes.campoTitulo}>
            <Typography>CARACTERÍSTICAS GERAIS</Typography>
          </Grid>
          <Grid item container xs={12} className={classes.formContent} spacing={2}>
            <Grid item md={3} sm={6} xs={12}>
              <FreeSolo
                form={formDescricaoTecnica}
                required
                prop="tipo"
                label="TIPO"
                options={tiposElementoRecarga}
              />
            </Grid>
            <Grid item md={9} sm={12} xs={12}>
              <TextField
                label="CARACTERÍSTICAS"
                required
                name="outrasCaracteristicas"
                variant="outlined"
                value={formDescricaoTecnica.formState.values.outrasCaracteristicas || ''}
                onChange={formDescricaoTecnica.handleChange}
                fullWidth
                InputLabelProps={{
                  shrink: true,
                }}
              />
            </Grid>
            <Grid item md={4} sm={4} xs={12}>
              <TextField
                label="EMBALAGEM PRIMÁRIA"
                name="embalagemPrimaria"
                variant="outlined"
                value={formDescricaoTecnica.formState.values.embalagemPrimaria || ''}
                onChange={formDescricaoTecnica.handleChange}
                fullWidth
                InputLabelProps={{
                  shrink: true,
                }}
              />
            </Grid>
            <Grid item md={4} sm={4} xs={12}>
              <TextField
                variant="outlined"
                label="QUANTIDADE"
                required
                fullWidth
                value={formDescricaoTecnica.formState.values.quantidade}
                InputLabelProps={{
                  shrink: true,
                }}
                name="quantidade"
                onChange={(e) => {
                  const input = e.target.value
                  const regex = /^\d*\.?\d*$/
                  if (regex.test(input)) {
                    formDescricaoTecnica.handleChange(e)
                  }
                }}
                error={formDescricaoTecnica.hasError('quantidade')}
                helperText={
                  formDescricaoTecnica.hasError('quantidade')
                    ? formDescricaoTecnica.formState.errors.quantidade[0]
                    : null
                }
              />
            </Grid>
            {formDescricaoTecnica.formState.values.tipo !== 'Espoleta' && (
              <Grid item md={4} sm={4} xs={12}>
                <FreeSolo
                  form={formDescricaoTecnica}
                  required
                  prop="unidadeQuantidade"
                  label="UNIDADE"
                  options={['un', 'g', 'mm', 'mL', 'mg', 'kg', 'L']}
                />
              </Grid>
            )}
            {formDescricaoTecnica.formState.values.tipo === 'Espoleta' && (
              <Grid item md={4} sm={4} xs={12}>
                <TextField
                  variant="outlined"
                  label="QUANTIDADE TESTADA"
                  required
                  fullWidth
                  value={formDescricaoTecnica.formState.values.unidadesConsumidas}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  name="unidadesConsumidas"
                  onChange={(e) =>
                    formDescricaoTecnica.handleChangeWithModification(e, numeroMenorQueQuantidade)
                  }
                  error={formDescricaoTecnica.hasError('unidadesConsumidas')}
                  helperText={
                    formDescricaoTecnica.hasError('unidadesConsumidas')
                      ? formDescricaoTecnica.formState.errors.unidadesConsumidas[0]
                      : null
                  }
                />
              </Grid>
            )}
          </Grid>
        </>
      )}

      {tipoEspecifico === 'CARREGADOR' && (
        <>
          <Grid item xs={12} className={classes.campoTitulo}>
            <Typography>CARACTERÍSTICAS GERAIS</Typography>
          </Grid>
          <Grid item container xs={12} className={classes.formContent} spacing={2}>
            <Grid item md={2} sm={4} xs={8}>
              <TextField
                variant="outlined"
                label="UNIDADES"
                required
                fullWidth
                value={formDescricaoTecnica.formState.values.unidades}
                InputLabelProps={{
                  shrink: true,
                }}
                name="unidades"
                onChange={(e) => {
                  const input = e.target.value
                  const regex = /^[1-9]\d*$/
                  if (regex.test(input) || input === '') {
                    formDescricaoTecnica.handleChange(e)
                  }
                }}
                error={formDescricaoTecnica.hasError('unidades')}
                helperText={
                  formDescricaoTecnica.hasError('unidades')
                    ? formDescricaoTecnica.formState.errors.unidades[0]
                    : null
                }
              />
            </Grid>
            <Grid item md={3} sm={6} xs={12}>
              <FreeSolo
                form={formDescricaoTecnica}
                required
                prop="tipo"
                label="TIPO"
                options={tiposCarregadores}
              />
            </Grid>
            <Grid item md={4} sm={4} xs={12}>
              <TextField
                required
                label="CAPACIDADE DO CARREGADOR"
                name="capacidade"
                variant="outlined"
                value={formDescricaoTecnica.formState.values.capacidade || ''}
                onChange={(e) => {
                  const input = e.target.value
                  const regex = /^[1-9]\d*$/
                  if (regex.test(input) || input === '') {
                    formDescricaoTecnica.handleChange(e)
                  }
                }}
                fullWidth
                InputLabelProps={{
                  shrink: true,
                }}
              />
            </Grid>
            <Grid item md={4} sm={4} xs={12}>
              <TextField
                required
                label="CALIBRE"
                name="calibreNominal"
                variant="outlined"
                value={formDescricaoTecnica.formState.values.calibreNominal || ''}
                onChange={formDescricaoTecnica.handleChange}
                fullWidth
                InputLabelProps={{
                  shrink: true,
                }}
              />
            </Grid>
            <Grid item md={8} sm={8} xs={12}>
              <FreeSolo
                form={formDescricaoTecnica}
                prop="fabricante"
                label="FABRICANTE"
                options={marcasArmaDeFogo}
              />
            </Grid>
            <Grid item md={4} sm={4} xs={12}>
              <TextField
                label="MODELO"
                name="modelo"
                variant="outlined"
                value={formDescricaoTecnica.formState.values.modelo || ''}
                onChange={formDescricaoTecnica.handleChange}
                fullWidth
                InputLabelProps={{
                  shrink: true,
                }}
              />
            </Grid>
            <Grid item xs={12}>
              <SelectTextField
                form={formDescricaoTecnica}
                prop="locFabs"
                label="LOCAL DE FABRICAÇÃO"
                propInput="localFabricacaoInput"
                labelInput="LOCAL DE FABRICAÇÃO (ESPECIFICAR)"
                options={locaisFabricacao}
                isValoresObjeto
                multiple
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                label="OUTRAS CARACTERÍSTICAS"
                name="outrasCaracteristicas"
                variant="outlined"
                value={formDescricaoTecnica.formState.values.outrasCaracteristicas || ''}
                onChange={formDescricaoTecnica.handleChange}
                fullWidth
                InputLabelProps={{
                  shrink: true,
                }}
              />
            </Grid>
          </Grid>
        </>
      )}

      {tipoEspecifico === 'ARTEFATO' && (
        <Grid item xs={12} style={{ padding: '20px 0' }}>
          <Typography variant="body1" align="center">
            ARTEFATO
          </Typography>
        </Grid>
      )}
    </Grid>
  )
}

FormDescricaoVestigioBalistico.propTypes = {
  formDescricaoTecnica: PropTypes.object.isRequired,
  tipoExame: PropTypes.string,
  descricaoDuplicada: PropTypes.bool,
}
